<template>
  <div>
    <div class="head">
      Admin Logs
    </div>

    <div class="log-box">
      <div class="log-label d-flex justify-space-between">
        <div>
          Auto Dispatch RUN
          <i class="fas fa-spinner fa-spin loader" v-if="loading"></i>
        </div>
        <b @click="getLogs" v-if="!loading" class="refresh">REFRESH</b>
      </div>

      <div class="box" v-for="(log, i) in logs" :key="i" v-show="!loading">
        <div class="details">
          <table>
            <tr>
              <td>ID</td>
              <td>{{log.id}}</td>
            </tr>
            <tr>
            <tr>
              <td>RUN ID</td>
              <td>{{log.runId}}</td>
            </tr>
            <tr>
              <td>Created UTC</td>
              <td>{{log.createdUTC}}</td>
            </tr>
            <tr>
              <td>Executed UTC</td>
              <td>{{log.executedUTC}}</td>
            </tr>
            <tr>
              <td>RSVP IDs</td>
              <td>
                [<a v-for="(rsvp, r) in log.rsvpIds" :href="`#/reservation/${rsvp}`" target="_blank" :key="r">{{rsvp}}</a>]
              </td>
            </tr>
            <tr>
              <td>Sector ID</td>
              <td>{{log.sectorId || '--'}}</td>
            </tr>
            <tr>
              <td>Qualified Sector</td>
              <td>{{log.qualifiedSector || '--'}}</td>
            </tr>
            <tr>
              <td>Qualified Miles</td>
              <td>{{log.qualifiedMiles}}</td>
            </tr>
            <tr>
              <td>Sent Driver ID</td>
              <td>{{log.sentDriverId || '--'}}</td>
            </tr>
            <tr>
              <td>Moved Pool</td>
              <td>{{log.movedPool}}</td>
            </tr>
            <tr>
              <td>Message</td>
              <td>{{log.message}}</td>
            </tr>
          </table>
        </div>

        <div class="data">
          <div class="data-box">
            <b>ERROR</b>
            <span v-if="log.error">[<a @click="toggleView(log.id, 'beautifyError')">switch view</a>]</span>
            <br/>
            <div v-if="log.error">
              <pre v-if="beautifyError.indexOf(log.id) > -1">{{log.error}}</pre>
              <div v-else class="raw">{{log.error}}</div>
            </div>
            <div v-else>No error.</div>
          </div>
          <div class="data-box">
            <b>Send Payload</b>
            <span v-if="log.sendPayload">[<a @click="toggleView(log.id, 'beautifySendPayload')">switch view</a>]</span>
            <br/>
            <div v-if="log.sendPayload">
              <pre v-if="beautifySendPayload.indexOf(log.id) > -1">{{log.sendPayload}}</pre>
              <div v-else class="raw">{{log.sendPayload}}</div>
            </div>
            <div v-else>--</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'admin-logs',
  data () {
    return {
      loading: false,
      logs: [],
      beautify: [],
      beautifyError: [],
      beautifySendPayload: [],
      errorMsg: ''
    }
  },
  computed: {
  },
  methods: {
    getLogs () {
      let self = this

      self.loading = true
      self.$sdk.get('/runs/autodispatch/events', {
        token: self.$store.state.session.sessionToken
      }, res => {
        self.loading = false
        if (res.error) {
          self.errorMsg = res.error.message
          return
        }
        self.logs = res.list
      }, '2.0')
    },
    toggleView (id, field) {
      let index = this[field].indexOf(id)
      if (index > -1) this[field].splice(index, 1)
      else this[field].push(id)
    }
  },
  mounted () {
    this.getLogs()
  }
}
</script>

<style lang="scss" scoped>
.head{
  height: 50px;
  font-weight: 600;
  color: #fff;
  padding: 0 10px;
  width: calc(100% - 50px);
  margin-left: 50px;
  font-size: 21px;
  line-height: 50px;
  background: #333;
}

.log-box{
  font-family: 'Space Grotesk', sans-serif;
  margin: 20px 10px;
  padding: 15px;
}
.log-label{
  font-size: 21px;
  font-weight: 600;
  margin-bottom: 10px;

  .loader{
    margin-left: 10px;
    color: #5291d8;
  }
}
.refresh{
  font-size: 16px;
  color: #0D79F2;
  cursor: pointer;
}
.box{
  border-radius: 6px;
  border: 1px solid #aaa;
  background: #fff;
  overflow: hidden;
  display: flex;
  margin-bottom: 20px;

  .details{
    padding: 10px;
    background: #eaeff3;
    width: 370px;
    border-right: 1px solid #aaa;

    table{
      width: 100%;
      font-size: 14px;

      td:nth-child(1){
        color: #717b85;
        width: 120px;
      }
      td:nth-child(2){
        text-align: right;
        font-weight: 600;
        color: #343d45;

        a{
          margin:0 2px;
        }
      }
    }
  }
  .data{
    background: #fff;
    width: calc(100% - 351px);
    padding: 15px;
    font-size: 15px;
    font-family: monospace,monospace;

    b{
      margin-right: 10px;
    }
    a{
      cursor: pointer;
    }
    pre{
      width: 100%;
      white-space: pre-wrap;
    }
    .raw{
      word-wrap: break-word;
    }
    .data-box{
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
  }
}

@media only screen and (max-width: 900px) {
  .box{
    flex-direction: column!important;

    .details{
      width: 100%;
      border-right: none;
      border-bottom: 1px solid #aaa;
    }
    .data{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/devlogs/auto-dispatch.vue